'use strict';
angular.module('atex.dam').factory("DamQueryService", ['$q', 'ContentService', 'SearchService', 'DamService', 'AuthenticationService',
function($q, ContentService, SearchService, DamService, AuthenticationService) {
  function DamQueryService( ) {
  }

  // We use dam.system.d in order to have power users, i.e. with home dept in Dam or above to be able to
  // create a query and share it whit users in dam.assets.d, dam.assetsOther.d, etc [max]
  var querySecParentId = "dam.system.d";

  DamQueryService.createQuery = function (queryContentData) {
    return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      var secParentId = 'externalid/' + querySecParentId;
      var insParentId = secParentId;
      var homeDep = currentUserInfo.homeDepartmentId;
      // PMC-1624: adding 2.1 to exclusion list.
      // 2.0 is RootDepartment, 2.1 is SiteEngine, in both cases we should not use that as insertParentId
      // otherwise the content will not have any page_ss in the solr document
      if (homeDep && homeDep !== 'policy:2.0' && homeDep !== 'policy:2.1') {
        insParentId = 'contentid/' + homeDep;
      }
      var transferInfo = {
        data: {
          aspects: {
            'p.InsertionInfo': {
              data: {
                _type: 'p.InsertionInfo',
                securityParentId: secParentId,
                insertParentId: insParentId
              }
            },
            'contentData': queryContentData,
            'atex.dam.standard.ContentAccess': {
              data: {
                _type: 'atex.dam.standard.ContentAccess',
                "assignees": [
                  {
                    "externalId": currentUserInfo.externalId,
                    "owner": true
                  }
                ],
                "creator": currentUserInfo.loginName
              }
            }
          }
        }
      };
      return ContentService.createContent(transferInfo).then(function (response) {
        return ContentService.getContent({id: response.id});
      });
    });
  };

  DamQueryService.getAllQueries = function () {
    return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      return DamService.getSolrServerInfo().then(function (solrInfo) {
        var transferInfo = {};
        transferInfo['core'] = solrInfo.solrCore;
        transferInfo['variant'] = 'list';
        transferInfo['fl'] = 'id';
        transferInfo['q'] = '+type:(atex.dam.standard.Query)';
        if (currentUserInfo && !currentUserInfo.isAdm) {
          transferInfo['q'] += '+assignees_atex_desk_sms:(';
          transferInfo['q'] += currentUserInfo.externalId;
          for (var i = 0; currentUserInfo.groups && i < currentUserInfo.groups.length; i++) {
            var escaped = currentUserInfo.groups[i].principalId.replace(':', '\\:');
            transferInfo['q'] += ' OR ' + escaped;
          }
          transferInfo['q'] += ')';
        }
        return SearchService.search(transferInfo);
      });
    });
  };

  /** Starting from a content this function try to check if it's a page of an Hermes multipage (*) document
   * and in that case try to retrieve an array of contents belonging to the entire multipage
   * getContents: boolean to retrieve content of each page, if false retrieve only contentIds
   * (*) In Hermes a multipage document is composed of pages with same edition, pubdate, level,
   * named in sequence like PAGE=001, PAGE=002, ....
   **/
  DamQueryService.checkForMultiPage = function (content, getContents) {
    var _type = atex.onecms.ObjectUtils.getByPath(content, "data/aspects/contentData/data/objectType");
    if (_type === "page") {
      var pageName = atex.onecms.ObjectUtils.getByPath(content, "data/aspects/contentData/data/name");
      if (pageName && pageName.indexOf("=") > 0) {
        // Can be a MultiPage, let's try to lookup other pages
        var publEvents = atex.onecms.ObjectUtils.getByPath(content,
          "data/aspects/atex.dam.standard.Publevents/data/publevents");
        if (publEvents && publEvents[0]) {
          var edition = publEvents[0].edition;
          var pubdate = publEvents[0].pubdate;
          var pagelevel = publEvents[0].pagelevel;
          if (edition && pubdate && pagelevel) {
            var pageNameRadix = pageName.substring(0, pageName.indexOf("=") + 1);
            var searchInfo = {};
            searchInfo['q'] = "+atex_desk_objectType:(page)";
            searchInfo['q'] += "+name_atex_desk_ts:(\"" + pageNameRadix + "%\")";
            var utcPubdate = atex.dam.AngularUtils.toUTCDate(pubdate);
            // Patch for pubdate not UTC centered
            var dates = [utcPubdate, utcPubdate];
            atex.dam.ViewUtils.patchDateInterval(dates, true);
            searchInfo['q'] = searchInfo['q'] + "+_query_:\"{!parent%20which='contentType_atex_desk_s:parentDocument'}(";
            searchInfo['q'] += "+pubdate_atex_desk_dts:[" + dates.join(" TO ") + "]";
            searchInfo['q'] += "+edition_atex_desk_ss:(\\\"" + edition + "\\\")";
            searchInfo['q'] = searchInfo['q'] + ")\"";
            searchInfo['core'] = 'onecms';
            searchInfo['fl'] = 'id';
            return SearchService.search(searchInfo).then(function (queryResp) {
              var docs = atex.onecms.ObjectUtils.getByPath(queryResp,
                "data/response/docs") || [];
              if (!getContents || docs.length === 0) {
                return docs;
              }
              var promises = docs.map(function (item) {
                return ContentService.getContent({id: item.id});
              });
              return $q.all(promises).then(function (contents) {
                // sort by name
                contents = _.sortBy(contents, function (entry) {
                  return atex.onecms.ObjectUtils.getByPath(entry, "data/aspects/contentData/data/name") || '';
                });
                return contents;
              });
            });
          }
        }
      }
    }
    return $q.when([]);
  };

  DamQueryService.prototype = {
    constructor: DamQueryService
  };

  return(DamQueryService);
}]);
